import React from 'react'
import EContentSearch from 'src/modules/EContent/Search'

const EContentSearchPage = () => {
  return <EContentSearch />
}

export default EContentSearchPage
